import { AxiosRequestConfig } from 'axios';
import { Amplify, Storage } from '~/services';
import { REACT_APP_X_TOKEN } from '~/utils';

type CustomRequest = {
  authorization?: string;
};

export const interceptorsAuthHeaders = async (
  config: any,
): Promise<any & CustomRequest> => {

  const amplify = new Amplify();

  return {
    ...config,
    headers: {
      ...config.headers,
      'x-api-key': REACT_APP_X_TOKEN,
      'X-Tenant-Id': await amplify.getTenantId(),
      'X-User-Email': (await amplify.getUsername()).username,
      authorization: 'Bearer ' + await amplify.getToken(),
    },
  };
};
